import secureApi from "../services/secureApi";

export const viewInvoiceConfig = async () => {
  try {
    const response = await secureApi.get("/admin/viewConfig");
    return response.data;
  } catch (error) {
    console.error("Error loading invoice configuration:", error);
    throw error;
  }
};

export const updateInvoiceConfig = async (payload) => {
  try {
    const response = await secureApi.put("/admin/updateInvoiceConfig", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating invoice configuration:", error);
    throw error;
  }
};

export const createInvoiceConfig = async (payload) => {
  try {
    const response = await secureApi.post("/admin/createInvoiceConfig", payload);
    return response.data;
  } catch (error) {
    console.error("Error creating invoice configuration:", error);
    throw error;
  }
};
